import { Reducer } from 'redux';

import { IRecommendationSkuInfo } from '../models/GetDisplayInventoryRecommendationList';
import { PageInfo } from '../../../models/PageInfo';
import { IErrorActionData } from '../../../models/Error';
import { defaultPageSize } from '../../../constants/Common';
import {
  GetDisplayInventoryRecommendationListActionTypes,
  GetDisplayInventoryRecommendationListActions,
} from '../actions/GetDisplayInventoryRecommendationList';

export interface IDisplayInventoryRecommendationListState {
  skuList: Array<IRecommendationSkuInfo>;
  pageInfo: PageInfo;
  isProcessing: boolean;
  isSuccess: boolean;
  error?: IErrorActionData;
}

const initialDisplayInventoryRecommendationListState = {
  skuList: [] as Array<IRecommendationSkuInfo>,
  pageInfo: new PageInfo({
    pageSize: defaultPageSize,
    pageNumber: 0,
    hasNext: false,
    cursor: 0,
  }),
  isProcessing: false,
  isSuccess: false,
  error: undefined,
} as IDisplayInventoryRecommendationListState;

const GetDisplayInventoryRecommendationListReducer: Reducer<
IDisplayInventoryRecommendationListState, GetDisplayInventoryRecommendationListActions
> = (
  state = initialDisplayInventoryRecommendationListState,
  action: GetDisplayInventoryRecommendationListActions,
): IDisplayInventoryRecommendationListState => {
  switch (action.type) {
    case GetDisplayInventoryRecommendationListActionTypes.GET_DISPLAY_INVENTORY_RECOMMENDATION_LIST:
      return {
        ...state,
        isProcessing: true,
        isSuccess: false,
        error: undefined,
      };

    case GetDisplayInventoryRecommendationListActionTypes.GET_DISPLAY_INVENTORY_RECOMMENDATION_LIST_SUCCESS: {
      return {
        ...state,
        skuList: action.payload.skuList,
        pageInfo: new PageInfo({
          pageSize: action.payload.pageInfo.pageSize,
          hasNext: action.payload.pageInfo.hasNext,
          pageNumber: action.payload.pageInfo.pageNumber,
          totalPages: action.payload.pageInfo.totalPages,
          cursor: action.payload.pageInfo.cursor,
        }),
        isProcessing: false,
        isSuccess: true,
        error: undefined,
      };
    }

    case GetDisplayInventoryRecommendationListActionTypes.GET_DISPLAY_INVENTORY_RECOMMENDATION_LIST_FAILED:
      return {
        ...state,
        isProcessing: false,
        isSuccess: false,
        error: {
          errorCode: action.payload.errorCode,
          errorMessage: action.payload.errorMessage,
          callBack: action.payload.callBack,
        },
      };

    case GetDisplayInventoryRecommendationListActionTypes.GET_DISPLAY_INVENTORY_RECOMMENDATION_LIST_RESET:
      return initialDisplayInventoryRecommendationListState;

    default:
      return state;
  }
};

export default GetDisplayInventoryRecommendationListReducer;
